import { MapPin, MessageCircle } from "lucide-react";
import { Reveal } from "./Reveal";
import { IMAGES, WA_MESSAGES, wa, track } from "../../data/site";

export const FinalCTA = () => (
  <section className="px-4 py-10 sm:px-6 lg:px-8" data-testid="final-cta-section">
    <div className="grain relative mx-auto max-w-7xl overflow-hidden rounded-[2.5rem] bg-navy">
      <img
        src={IMAGES.lisbon}
        alt=""
        aria-hidden="true"
        loading="lazy"
        className="absolute inset-0 h-full w-full object-cover opacity-15"
      />
      <div
        className="absolute inset-0 bg-gradient-to-br from-navy via-navy/90 to-brand/40"
        aria-hidden="true"
      />
      <div
        className="absolute -right-24 -top-24 h-72 w-72 rounded-full bg-aqua/20 blur-3xl"
        aria-hidden="true"
      />

      <div className="relative px-6 py-20 text-center sm:px-12 lg:py-24">
        <Reveal>
          <h2 className="mx-auto max-w-2xl text-balance text-3xl font-extrabold tracking-tight text-white sm:text-4xl lg:text-5xl">
            Está na hora de renovar os seus estofos?
          </h2>
        </Reveal>
        <Reveal delay={0.1}>
          <p className="mx-auto mt-5 max-w-xl text-base leading-relaxed text-white/70 md:text-lg">
            Solicite o seu orçamento gratuito e descubra como podemos ajudar.
          </p>
        </Reveal>
        <Reveal delay={0.2}>
          <a
            href={wa(WA_MESSAGES.default)}
            target="_blank"
            rel="noopener noreferrer"
            id="cta-final"
            data-testid="cta-final-whatsapp"
            data-event="quote_request"
            onClick={() => track("quote_request", { location: "final_cta" })}
            className="cta-whatsapp cta-orcamento mt-9 inline-flex items-center gap-2.5 rounded-full bg-whatsapp px-8 py-4 text-base font-semibold text-white shadow-xl shadow-whatsapp/25 transition-all duration-300 hover:-translate-y-0.5 hover:bg-whatsapp-hover hover:shadow-2xl hover:shadow-whatsapp/35"
          >
            <MessageCircle className="h-5 w-5" />
            Solicitar Orçamento Gratuito
          </a>
        </Reveal>
        <Reveal delay={0.3}>
          <p className="mt-6 flex items-center justify-center gap-2 text-sm font-medium text-white/60">
            <MapPin className="h-4 w-4 text-aqua" />
            Atendimento em Lisboa e região
          </p>
        </Reveal>
      </div>
    </div>
  </section>
);
